import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import classnames from 'classnames'

import Form from '../settings/Form'
import { present } from '../settings/Form/validators'

import AutoCompleteLeads from '../../../util/auto_complete/Leads'
import AutoCompleteSearches from '../../../util/auto_complete/Searches'

@inject('websites', 'recommended_searches')
@observer
export default class AddRecommendedSearch extends Component {
  website = this.props.websites.current

  state = {
    successModalDisplay: false,
    newRecSearch: null
  }

  handleData = data => {
    return this.props.recommended_searches.create(data).
      then(newRecSearch => { this.setState({successModalDisplay: true, newRecSearch: newRecSearch}) })
  }

  handleRedirect = () => {
    this.props.router.push({
      pathname: `/website/${this.website.id}/recommended/searches`,
      state: { highlight: this.state.newRecSearch.id }
    })
  }

  handleSelectLead = lead => {
    this.selectedLeadId = lead.id
  }

  handleSelectSearch = search => {
    this.selectedSearchId = search.id
  }

  handleFreq = event => {
    this.selectedEmailFrequency = event.target.value
  }

  returnToState() {
    const selected = {}
    if (this.selectedLeadId) selected.lead_id = this.selectedLeadId
    if (this.selectedSearchId) selected.search_id = this.selectedSearchId
    if (this.selectedEmailFrequency) selected.email_frequency = this.selectedEmailFrequency
    return { ...this.getDefaults(), ...selected }
  }

  createLead = () => {
    const { router } = this.props
    router.replace({
      pathname: `/website/${this.website.id}/leads/invite`,
      state: { return_to: { ...router.location, state: this.returnToState() } }
    })
  }

  createSearch = () => {
    const { router } = this.props
    router.replace({
      pathname: `/website/${this.website.id}/searches/add`,
      state: { return_to: { ...router.location, state: this.returnToState() } }
    })
  }

  getDefaults() {
    const { state={}, query } = this.props.location
    const { lead_id } = this.props.params
    return { ...(lead_id && { lead_id }), ...state, ...query }
  }

  displayConfirmationSuccess() {
    if (this.state.successModalDisplay) return false
    return true
  }

  displayForm() {
    return !this.displayConfirmationSuccess()
  }

  render() {
    const validations = [
      { field: 'lead_id', validate: present, message: 'Please select a Lead' },
      { field: 'search_id', validate: present, message: 'Please select a Search' }
    ]
    const defaults = this.getDefaults()
    return (
      <div className="container centered padded website-page">
        <div className={classnames('panel padded confirmation',
                                   {hide: this.displayConfirmationSuccess()}) }>
          <h1>New Search Subscription Created</h1>
          <p>
            They will start receiving emails when there is a listing match, depending on the
            frequency you selected. Based on the search criteria you picked this could be within an
            hour or could take some time for them to get their first email contact.
          </p>
          <button className={classnames('button medium')}
                  onClick={this.handleRedirect}>Continue</button>
        </div>

        <Form className={ classnames('full',
                                     {hide: this.displayForm()}) }
              onData={this.handleData}
              validations={validations} >
          <div className="panel padded">
            <h2 className="title">Search Recommendation</h2>

            <div className="form-section">
              <label>Select a Lead</label>
              <p className="muted">This lead will receive the recommended search.</p>
              <AutoCompleteLeads
                name="lead_id"
                selected={defaults.lead_id}
                onSelect={this.handleSelectLead}
                onCreateNew={this.createLead} />
            </div>

            <div className="form-section">
              <label>Search</label>
              <p className="muted">The search to be recommended.</p>
              <AutoCompleteSearches
                name="search_id"
                selected={defaults.search_id}
                onSelect={this.handleSelectSearch}
                onCreateNew={this.createSearch} />
            </div>

            <div className="form-section">
              <label>Email Frequency</label>
              <p className="muted">How often should this subscription send emails</p>
              <select defaultValue={defaults.email_frequency} name="email_frequency" onChange={this.handleFreq}>
                <option value="instant">Instant</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="never">Never</option>
              </select>
            </div>
          </div>

          <button type="submit" className="big shadowed">Create New Search Subscription</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/RecommendedSearches/Add.js